<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container;
</script>

<BaseAtom _isotope="PartnershipGraphAtom" {...container}>
  <div>Partnership Graph Placeholder</div>
</BaseAtom>
